import * as React from 'react'
import { ConnectedRouter } from 'connected-react-router'
import RoutesWrapper from '../common/Routes/RoutesWrapper'
import './Root.scss'
import OfflineSnackbarWrapper from '../components/OfflineSnackbar/OfflineSnackbarWrapper'
import { GlobalWorkoutConfirmationModal } from '../components/GlobalWorkoutConfirmationModal/GlobalWorkoutConfirmationModal'
import { SkipLink } from '../components/a11y/SkipLink'
import { installAriaLabelEnforcer } from '../components/a11y/enforceAriaLabels'
import { installModalityTracker } from '../components/a11y/trackModality'

installAriaLabelEnforcer()
installModalityTracker()

export interface IRootProps {
  history: any
}

export class Root extends React.Component<IRootProps> {
  render() {
    const { history } = this.props

    return (
      <ConnectedRouter history={history}>
        <SkipLink targetId="content" />
        <OfflineSnackbarWrapper />
        <RoutesWrapper />
        <GlobalWorkoutConfirmationModal />
      </ConnectedRouter>
    )
  }
}
